const Style = (theme) => ({
  new__ro__dialog: {
    width: '56rem',
    height: '70vh',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '98%',
      width: '98%',
    },
  },
  header: {
    padding: '1rem',
  },
  upgrade__plan__heading: {
    fontWeight: '600',
    fontSize: '20px',
    lineHeight: '34px',
    color: '#000',
  },
  semi__heading: {
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '26px',
    color: '#545B7D',
  },
  package__info: {
    margin: '1rem 2rem 0rem 2rem',
  },
  content__height: {
    padding: '.2rem 1rem 3rem',
    height: 'calc(100% - 155px)',
    overflow: 'auto',
  },
  current__subscription__detail: {
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '26px',
    color: '#545b7d',
    margin: ' 0.1rem 0rem 0.5rem 0rem',
  },
  plans__checkbox__main__container: {
    background: '#ffffff',
    borderRadius: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '2%',
  },
  checkbox__text__container: {
    padding: '0 1rem .5rem',
    border: '1.5px solid rgba(109, 125, 139, 0.4)',
    borderRadius: '10px',
    width: '32%',
    cursor: 'pointer',
    userSelect: 'none',
    '& .formlabel__control': {
      margin: '1rem 0 0.5rem',
      '& .main__checkbox': {
        margin: '0',
        padding: '0',
        '& svg': {
          height: '25px',
          width: '25px',
        },
      },
      '& .Mui-checked': {
        '& .MuiIconButton-label': {
          '& svg': {
            '& rect': {
              fill: 'var(--color-success)',
            },
          },
        },
        color: 'var(--color-primary) !important',
      },
    },
  },
  border__primary: {
    border: '1.5px solid var(--color-primary)',
  },
  package__details: {
    padding: '0.5rem 0rem 0rem 0.9rem',
  },
  package__title: {
    fontWeight: '500',
    fontSize: '15px',
    lineHeight: '12px',
    color: '#868b8f',
    paddingBottom: '0.5rem',
  },
  notification__settings__heading: {
    fontWeight: 'bold',
    fontSize: '30px',
    lineHeight: '36px',
    color: '#263238',
  },
  package__price: {
    fontWeight: '900',
    fontSize: '18px',
    lineHeight: '26px',
    color: '#868b8f',
  },
  package__duration: {
    fontSize: '10px',
    color: '#6D7D8B',
  },
  package__type: {
    fontWeight: '600',
    fontSize: '12px',
  },
  payment__details: {
    fontWeight: '700',
    fontSize: '13px',
    color: '#545b7d',
    margin: '0.8rem 0rem',
  },

  agreed__terms__container: {
    '& .MuiCheckbox-root': {
      padding: '1% 1% 1% 0%',
    },
  },
  terms__agreement: {
    fontWeight: '500',
    fontSize: '13px',
    color: '#6d7d8b',
  },
  pay__now__btn__container: {
    justifyContent: 'space-between',
    padding: '4% 0% 2% 0%',
  },
  pay__now__btn: {
    background: '#ff6019',
    color: '#fff',
    borderRadius: '107px',
    padding: '0.4rem 2.5rem',
    '&:hover': {
      background: '#ff6019',
    },
  },
  back__btn: {
    fontSize: '13px',
    borderRadius: '100px',
    height: '38px',
    width: 'max-content',
    minWidth: 'max-content',
    fontWeight: '500',
    textTransform: 'capitalize',
    justifyContent: 'flex-start',
    color: 'rgba(109, 125, 139, 0.8)',
    transition: '0.3s',
    background: 'transparent',
    '&:hover': {
      background: 'transparent',
      color: 'rgb(45, 68, 87)',
    },
  },
  toggle__switch: {
    width: '37px',
    height: '20px',
    borderRadius: '30px',
    padding: '0',
    margin: '0 .5rem',
    '& .MuiSwitch-switchBase': {
      padding: '0',
      color: '#fff',
      height: '100%',
      left: '.01rem',
    },
    '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
      backgroundColor: 'var(--color-primary)',
      opacity: '1',
    },
    '& .MuiSwitch-track': {
      backgroundColor: 'var(--color-primary)',
      opacity: '1',
    },
    '& .MuiSwitch-thumb': {
      width: '12px',
      height: '12px',
      marginLeft: '2px',
    },
  },
  toggle__label: {
    fontSize: '14px',
    lineHeight: '19px',
    fontWeight: '600',
    color: 'rgba(38, 50, 56, .6)',
  },
  active__label: {
    color: '#263238',
  },
  terms__n__condition: {
    '& .inputs__main__div': {
      background: '#ffffff',
      borderRadius: '10px',
      padding: '0',
      '& .grid__gapping': {
        padding: '0.6rem 0.7rem',
      },
    },

    '& .formlabel__control': {
      margin: '1rem 0 0.5rem',
      '& .MuiFormControlLabel-label': {
        fontWeight: '500',
        fontSize: '13px',
        lineHeight: '15px',
        color: '#6d7d8b',
        userSelect: 'none',
      },
      '& .main__checkbox': {
        margin: '0 0.3rem 0 0',
        padding: '0',
      },
      '& .Mui-checked': {
        '& .MuiIconButton-label': {
          '& svg': {
            '& rect': {
              fill: 'var(--color-success)',
            },
          },
        },
        color: 'var(--color-primary) !important',
      },
    },
  },
  upgrade__heading: {
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '23px',
    color: '#868B8F',
  },
  upgrade__semi__heading: {
    fontSize: '28px',
    lineHeight: '38px',
    color: '#868B8F',
    fontWeight: 'bold',
    paddingTop: '0.5rem',
    '& .sm__per': {
      fontSize: '14px',
    },
  },
  form__control__label: {
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '28px',
    color: '#6D7D8B',
    padding: '0 0.5rem 2rem',
  },
  universal__pkg__icon__inactive: {
    '& rect': {
      fill: '#e4b9a7',
    },
    '& path': {
      fill: '#dedad9',
    },
  },
  businessPlus__pkg__icon__inactive: {
    '& rect': {
      fill: '#9576bc',
    },
    '& path': {
      fill: '#9576bc',
    },
  },

  growth__pkg__icon__inactive: {
    '& rect': {
      fill: '#f4b69a',
    },
    '& path': {
      fill: '#FFF',
    },
  },

  active__upgrade__heading: {
    color: 'var(--color-primary)',
  },
  active__semi__heading: {
    color: '#29264A',
  },
  disabled__btn: {
    color: '#6d7d8b !important',
    background: '#ececee !important',
  },
});
export default Style;
